<template>
  <div class="login-wrap">
    <div class="login-top">
      <login-top />
      <div class="content-part">
        <img class="left-logo" src="@/assets/img/kcc-logo-encn.png" width="100%" />
        <div :class="appendLoginFormHeight">
          <div class="title-line">
            <span :class="['ms-title', $i18n.locale === 'en' ? 'en-lang' : '']">{{ $t('login_welcome_1') }}</span>
            <span class="ms-title" :class="{ 'en-lang': $i18n.locale === 'en' }"> {{ $t('login_welcome_2') }}</span>
          </div>
          <div class="font-light1">

            <el-steps simple class="mb_20 zh-last" :class="[$i18n.locale === 'en' ? 'en-last1' : 'zh-last']"
              :active="currentStep" finish-status="success">
              <el-step class="step-name">
                <template slot="title">
                  <span class="mr_4">{{ $t('login.step1') }}</span>
                  <el-tooltip placement="top" :content="$t('login_step1_tip')">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                  <div class="circle-group" :class="{ en: $i18n.locale === 'en' }">
                    <span class="big-circle"></span>
                    <span class="small-circle"></span>
                    <span class="small-circle"></span>
                    <span class="small-circle "></span>
                    <span class="step-arrow"></span>
                  </div>
                </template>
              </el-step>
              <el-step class="step-name " :class="{ 'step-number': currentStep === 1 }" :title="$t('login.step2')">
                <template slot="title">
                  <svg-icon v-if="currentStep === 1" icon-name="numberTwo" size="17" class="mr_4"></svg-icon>
                  <span class="mr_4">{{ $t('login.step2') }}</span>
                  <el-tooltip placement="top">
                    <div slot="content" v-html="$t('login_step2_tip')"></div>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                  <div class="circle-group" :class="{ en: $i18n.locale === 'en' }">
                    <span class="big-circle"></span>
                    <span class="small-circle"></span>
                    <span class="small-circle"></span>
                    <span class="small-circle "></span>
                    <span class="step-arrow"></span>
                  </div>
                </template>
              </el-step>
              <el-step class="step-name step3"
                :class="[{ 'step-number': currentStep < 3 }, { 'left-20': $i18n.locale === 'en' }]" :title="$t('login.step3')">
                <template slot="title">
                  <svg-icon class="mr_4" v-if="currentStep < 3" icon-name="numberThree" size="17"></svg-icon>
                  <span class="mr_4">{{ $t('login.step3') }}</span>
                </template>
              </el-step>
            </el-steps>
            <!-- <p >
               <span  class="font-weight">{{$t('login.step')}} {{currentStep}}/3 </span> {{$t('login.step'+currentStep)}}
            </p> -->
          </div>

          <el-tabs class="cust-tabs" type="border-card" v-if="currentStep === 3" v-model="param.verificationCodeType"
            @tab-click="handleTabClick">
            <el-tab-pane v-for="tab in tabs" :key="tab.code" :name="tab.code" :label="tab.name">
              <span slot="label" class="tab-label">
                <SvgIcon class="way-icon" :icon-name="tab.icon" size="20"
                  :icon-color="param.verificationCodeType === tab.code ? '#005eb8' : 'rgb(38 47 63)'"></SvgIcon>
                {{ $t(tab.name) }}
              </span>
            </el-tab-pane>
          </el-tabs>
          <el-form :model="param" :rules="rules" ref="login" label-width="0px" onsubmit="return false"
            class="ms-content login-form">

            <template v-if="currentStep === 1">
              <el-form-item style="margin-bottom:18px"
                :class="accountFlag ? 'item checkAccount' : 'item checkAccount is-error'" prop="account">
                <div :class="accountFocus || param.account ? 'label label-active' : 'label'"
                  @click="() => { $refs.accountInput.focus() }">{{ $t('login.forgotAccount') }}</div>
                <el-input @keyup.prevent.enter.native="next" class="right-btn-item" ref="accountInput"
                  v-model="param.account" @blur="accountFocus = false" @focus="focusAccount">
                </el-input>
                <div v-if='!accountFlag' class="el-form-item__error">
                  {{ errorMsgShow }}
                </div>
              </el-form-item>
            </template>

            <template v-else-if="currentStep === 2">
              <el-form-item class="item" prop="password">
                <div :class="pwdFocus || param.password ? 'label label-active' : 'label'"
                  @click="() => { $refs.pwdInput.focus() }">{{ $t('login_passWorld') }}</div>
                <el-input show-password ref="pwdInput" v-model="param.password" @keyup.prevent.enter.native="next"
                  @blur="pwdFocus = false" @focus="pwdFocus = true">
                </el-input>
              </el-form-item>
            </template>

            <template v-else>
              <!-- 邮箱登录 -->
              <el-form-item v-if="param.verificationCodeType === 'EMAIL'" class="mb_40 item checkAccount" prop="account">
                <div :class="param.account ? 'label label-disabled-active' : 'label'">{{ $t('login_account') }}</div>
                <el-input ref="loginAccountInput" disabled v-model="param.account">
                </el-input>
                <div v-if='!accountFlag' class="el-form-item__error">
                  {{ errorMsgShow }}
                </div>
              </el-form-item>

              <el-form-item v-else class="item code-item mb_40" prop="receiverNumber"
                :class="phoneFlag ? 'item checkAccount' : 'item checkAccount is-error'">
                <div class="label label-active" :class="{ 'label-disabled-active': phoneDisabled }"
                  @click="() => { $refs.phoneInput.focus() }">{{ $t('login.phone') }}</div>
                <el-input class="phone-input" @keyup.enter.native="submitForm()" ref="phoneInput"
                  :placeholder="$t('login.phone')" v-model="param.receiverNumber" :disabled='phoneDisabled'
                  :class="['right-btn-item', codeBtn ? 'code_disabled' : '']"
                  @change="param.receiverNumber = param.receiverNumber.trim()" @blur="handlePhoneBlur"
                  @focus="() => { phoneFocus = true; phoneFlag = true }">
                  <template slot="prepend">
                    <el-select class="phone-prepend left-btn-item" :class="{ 'zh-width': $i18n.locale === 'zh' }"
                      :disabled='phoneDisabled' v-model="regionPhone" slot="prepend" placeholder="请选择">
                      <el-option :label="$t('login.china')" value="+86"></el-option>
                      <el-option :label="$t('login.HongKong')" value="+852"></el-option>
                      <el-option :label="$t('login.Macau')" value="+853"></el-option>
                    </el-select>
                  </template>
                </el-input>
                <div v-if='!phoneFlag' class="el-form-item__error">
                  {{ errorMsgShow }}
                </div>
              </el-form-item>

              <el-form-item class="item code-item" prop="verificationCode">
                <div :class="codeFocus ? 'label label-active' : 'label'" @click="() => { $refs.codeInput.focus() }">{{
          $t('login_verification_Code') }}</div>
                <el-input @keyup.enter.native="submitForm()" ref="codeInput" v-model="param.verificationCode"
                  :class="['right-btn-item', codeBtn ? 'code_disabled' : '']" @focus="codeFocus = true">
                  <template slot="append">
                    <el-button :disabled="codeBtn" class="login-btn" :loading="codeLoading" @click="getCode()"
                      type="primary">
                      {{ getCodeSecond > 0 ? `${getCodeSecond} s` : $t('login_btn_getCode') }}
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>

              <div class="footer-login">
                <el-button :loading="loginLoading" class="login-item" type="primary" @click="submitForm()">
                  {{ $t('login_btn_login') }}
                </el-button>
              </div>
              <el-form-item prop="termOfUse" v-show="firstLogin">
                <el-checkbox-group v-model="param.termOfUse">
                  <div class="login-terms-font" style="color:#584d4d;">
                    <el-checkbox name="termOfUse" style="padding-right: 4px;"></el-checkbox>
                    <div>{{ $t('login_read_terms') }}
                      <a href="javascript:void 0;" @click="navigateToTermOfUse()"
                        style="text-decoration: underline;color:#00338d;">{{ $t('login_terms') }}</a>
                      和
                      <a href="javascript:void 0;" @click="navigateToPerson()"
                        style="text-decoration: underline;color:#00338d;">{{
          $t('person_info_collect') }}</a>
                    </div>

                  </div>
                </el-checkbox-group>
              </el-form-item>
            </template>

          </el-form>
          <template v-if="currentStep === 2">
            <p class="login-tips" v-if="!firstLoginFlag"><a style="cursor: pointer" @click="goTo">{{ $t('login_forget')}}?</a></p>
            <p class="login-tips" v-if="firstLoginFlag"><a style="cursor: pointer" @click="sendEmail">{{ $t('login_forget_init_passWorld')}}?</a></p>
          </template>
          <el-button v-if="currentStep !== 3" :loading="btnLoading" class="next-btn" type="primary"
            @click="next">{{ nextLabel }}</el-button>
          <!-- <el-popover
                  :class="supportShow? 'manual-text1' : 'manual-text'"
                  placement="top-start"
                  trigger="hover">
            <span style="font-size: 12px">
              <span v-if="$i18n.locale === 'en'">Don’t know how to login? Click <span class="help-popover-text" @click="openVideo"> here </span> for a short video.<br></span>
              <span v-else>不知如何登录？请点击<span class="help-popover-text" @click="openVideo"> 这里 </span>查看操作视频。</span>
          </span>
            <pre class="help" slot="reference">{{$t('login_tip')}}</pre>
          </el-popover> -->
          <el-popover v-if="supportShow && false" class="manual-text2" placement="top-start" width="400" trigger="hover">
            <span style="font-size: 12px; white-space: pre-wrap;">{{ $t('manual2') }}</span>
            <pre class="help" slot="reference" @click="toogleSupportVisible">{{ $t('help_tip') }}</pre>
          </el-popover>
          <div class="manual-text2">

            <a target="_top" v-if="supportShow" href="mailto:cnfmkpmgclicbt@kpmg.com">{{ $t('help_tip') }}</a>
          </div>
        </div>
      </div>

    </div>
    <v-bottom></v-bottom>

    <el-dialog title="毕马威智联平台使用条款" :visible.sync="cnDialogVisible" width="600px">
      本使用条款规范了您对毕马威智联平台的访问和使用。
      <ul style="list-style: decimal;padding:0 20px;">
        <li>您对毕马威智联平台的免费访问和使用应遵守本使用条款。</li>
        <li>毕马威智联平台站点上的数据将被存储于位于中国上海的服务器中。</li>
        <li>毕马威向您授予非排他、免费、受限和可撤销的许可仅为服务之目的访问和使用毕马威智联平台以及该平台上由毕马威和/或任何毕马威全球性组织中的任何成员所或其代表不定期发布的内容（以下称“毕马威内容”）。</li>
        <li>您保证作为授权用户（“授权用户”）遵守本使用条款。您点击接受本使用条款构成您遵守本使用条款的承诺。</li>
        <li>您认可：与毕马威智联平台有关的所有知识产权均由毕马威或其许可方所有，且您在毕马威智联平台上或其中不享有任何类型的权利或权益。您进一步认可毕马威内容可能是机密的，您同意尊重该等内容的保密性。</li>
        <li>
          您不得：
          <ul class="sub-list" style="list-style: none;">
            <li data-index="a) ">
              在身处中国内地之外的任何地方时访问和/或使用毕马威智联平台（本条仅适用于授权用户是中国内地企业的雇员）；
            </li>
            <li data-index="b) ">
              允许任何第三方访问或使用毕马威智联平台，或代表任何第三方使用该平台（包括但不限于代表任何第三方运营任何形式的设施或运营软件服务或类似服务），除非本使用条款另有明确许可；
            </li>
            <li data-index="c) ">从毕马威智联平台处复制、翻译、修改、适配或创建衍生作品；</li>
            <li data-index="d) ">创建至毕马威智联平台或任何毕马威内容的互联网链接，或将任何毕马威内容嵌入或映射至任何其他服务器及无线或互联网设备；</li>
            <li data-index="e) ">
              尝试探寻或查看毕马威智联平台的源代码，或对该平台所使用的软件进行反向工程、修改、解密、提取、分解或反编译（除非您依法有权进行该等操作，且毕马威依法不得限制或防止该等操作，但您应及时提前通知毕马威您意图此举）；
            </li>
            <li data-index="f) ">
              尝试干预毕马威智联平台的正常工作，尤其不得尝试绕过安全、许可证控制或其他保护机制，或篡改、入侵或以其他方式破坏该平台或其任何相关网站、计算机系统、服务器、路由器或任何互联网设备；
            </li>
            <li data-index="g) ">在毕马威智联平台操作或使用过程中遮挡、修改或删除该平台上标明的或显示的任何版权声明、商标或其他所有权标识；或</li>
            <li data-index="h) ">
              通过毕马威智联平台上传、存储、发布、通过电子邮件发送、传输或实施其他手段提供任何侵犯他人的知识产权、数据保护、隐私或其他权利的内容，任何诽谤性或违反任何合同义务或保密义务的内容，任何淫秽、色情、威胁性、煽动暴力或仇恨、侮辱性、歧视性（不论出于何种理由）的内容，或违反适用法律法规或无权合法上传的内容（以下称“禁止内容”）；
            </li>
          </ul>
        </li>
        <li>
          您同意遵守毕马威不定期知会您的与使用毕马威智联平台相关的所有毕马威政策，包括安全、科技和风险管理政策、规定和指引。若您不同意新的或变更后的政策，则应立刻书面通知毕马威，毕马威可自行决定终止您使用毕马威智联平台的权限。您还同意当发现任何可能损害毕马威智联平台的安全事件或行为（例如授权用户密码被非法使用）时，及时书面通知毕马威。
        </li>
        <li>
          您承认尽管毕马威在设计毕马威智联平台时考虑了信息安全，并已采取措施通过该平台的在线隐私声明中所述的手段保护该平台的安全性，但是毕马威无法保证该平台不受黑客或其他非法第三方访问的影响。您也承认通过互联网传输信息并非完全安全，始终有可能会被第三方非法截获。
        </li>
        <li>
          毕马威不保证毕马威智联平台上发布的任何内容不含病毒和/或其他可能含有污染性或破坏性元素的代码。您应负责采取适当的信息技术安全防护手段（包括反病毒和其他安全检查），以满足您对自身通过该平台提供和访问的内容的安全性和可靠性的具体要求。毕马威不对该平台上可能提供的任何第三方网站的内容和超链接的内容承担责任。
        </li>
        <li>
          带宽、网络配置、计算机浏览器设置等技术因素均可能影响毕马威智联平台的速度和可用性。毕马威不保证该平台能够持续、无中断或无错误地运行，也不保证其与您的计算机浏览器或与您的计算机系统的任何其他部分的兼容性。您同意毕马威智联平台的访问可能会随时暂停、受限、被拒绝或关闭，并同意发布在该平台上的内容可能无法恢复。您作为授权用户应确保留存发布在平台上的所有内容的副本。毕马威不负责为您恢复或向您提供该平台上发布的任何内容。
        </li>
        <li>
          若因您违反本使用条款规定的任何义务使毕马威或其他毕马威成员所（分别及统称为“毕马威一方”）遭受第三方的任何索赔申诉或索赔威胁（包括与您发布禁止内容相关的索赔），您应对毕马威一方作出赔偿，保护毕马威一方不受伤害，并补偿和保护毕马威一方使任何毕马威一方免受因任何该等违反及索赔而造成的损失、损害、费用或责任。本条款中，“您”包括所有授权用户，而“毕马威一方”包括毕马威一方的各位及所有合伙人、成员、总监、雇员、代理商，以及受毕马威一方控制或与毕马威一方相关联的任何实体。
        </li>
        <li>
          您应对您在毕马威智联平台及该平台上发布的内容的所有使用自行承担责任。除非本使用条款中另有明确规定外，不存在适用于毕马威智联平台或任何毕马威内容的默示担保、保证或其他条款。本使用条款未限制或排除毕马威应承担因其重大过失或欺诈性不实陈述所导致的人员伤亡或财产损失的责任，或适用法律不得限制或排除的任何其他责任。在不违反本条前述规定的前提下，毕马威无论在何种情况下均不应对您的任何间接或后果性损失负责，也不对您的任何利润、收入、合同、数据、商誉或其他类似损失负责。由本使用条款导致或与其相关的毕马威的责任构成双方合同项下的责任的一部分，并受与该合同项下的责任相关条款约束，本文另有明确规定除外。
        </li>
        <li>
          一旦服务无论因何种原因终止，您应立刻停止访问和使用毕马威智联平台，毕马威可去活或删除相关用户账户，除非适用法律或专业标准另有保留此类账户的要求。毕马威保留出于任何原因终止您访问毕马威智联平台的权利，包括但不限于若发现您未经授权使用该平台或违反本使用条款。
        </li>
      </ul>
    </el-dialog>
    <el-dialog title="KPMG Collaboration Centre Terms of Use" :visible.sync="enDialogVisible" width="600px">
      <ul style="list-style: decimal;padding:0 20px;word-break: normal;overflow-wrap: break-word;">
        These Terms of Use govern the access to, and usage of, KPMG Collaboration Centre (“KCC”) by you.
        <li>Access to and use of KCC on a complimentary basis is subject to these Terms of Use.</li>
        <li>Data located in the KCC site will be stored on a server in China.</li>
        <li>KPMG grants to you a non-exclusive, royalty-free, limited and revocable license to access and use KCC and
          the
          content posted on it from time to time by or on behalf of KPMG and/or any of the member firms of the KPMG
          global
          organization of independent firms (“KPMG Content”), solely for the purpose of services.</li>
        <li>You warrant that as an authorised user (“Authorized User”), you will comply with these Terms of Use. By
          clicking
          the acceptance button for these Terms of Use, this shall constitute your commitment to comply with these Terms
          of
          Use in its entirety.</li>
        <li>You acknowledge that all intellectual property rights pertaining to KCC are owned by KPMG or its licensors
          and
          that you acquire no right or interest of any kind in or to KCC. You further acknowledge that KPMG Content may
          be
          confidential, and you agree to respect the confidentiality of such content.</li>
        <li>
          You will not:
          <ul class="sub-list" style="list-style: none;">
            <li data-index="a)">
              access and/or use KCC when you are outside the territory of mainland China (this restriction only applies
              to
              the Authorised User is an employee of an entity incorporated in mainland China);
            </li>
            <li data-index="b) ">
              except as expressly permitted by these Terms of Use, permit any third party to access or use KCC or use it
              on
              behalf of any third party (which includes without limitation operating any form of facility on behalf of
              any
              third party or operating a software bureau or similar service);
            </li>
            <li data-index="c) ">copy, translate, modify, adapt or create derivative works from KCC;</li>
            <li data-index="d) ">
              create internet "links" to KCC or any KPMG content, or "frame" or "mirror" any KPMG Content on any other
              server or wireless or Internet-based device;
            </li>
            <li data-index="e) ">
              attempt to discover or gain access to the source code for KCC or reverse engineer, modify, decrypt,
              extract,
              disassemble or decompile the software it employs (except to the extent that you are permitted to do so
              under
              applicable law in circumstances under which KPMG is not lawfully entitled to restrict or prevent the same,
              provided KPMG is given prompt advance notice of your intention to do so);
            </li>
            <li data-index="f) ">
              attempt to interfere with the proper working of KCC and, in particular, must not attempt to circumvent
              security, license control or other protection mechanisms, or tamper with, hack into or otherwise disrupt
              KCC
              or any associated website, computer system, server, router or any other internet-connected device;
            </li>
            <li data-index="g) ">obscure, amend or remove any copyright notice, trademark or other proprietary marking
              on,
              or visible during the operation or use of, KCC; or</li>
            <li data-index="h) ">
              use KCC to upload, store, post, email, transmit or otherwise make available any content that infringes any
              intellectual property rights or data protection, privacy or other rights of any other person, is
              defamatory or
              in breach of any contractual duty or any obligation of confidence, is obscene, sexually explicit,
              threatening,
              inciteful of violence or hatred, blasphemous, discriminatory (on any ground), or that does not comply with
              all
              applicable laws and regulations or not lawfully entitled to be uploaded (“Prohibited Content”).
            </li>
          </ul>
        </li>
        <li>
          You agree to comply with all KPMG policies including security, technology and risk management policies, rules,
          and
          guidelines relating to the use of KCC of which KPMG has notified you from time to time. If you do not agree to
          new
          or changed policies, then you will immediately advise KPMG in writing and KPMG may, in its sole discretion,
          terminate your use of KCC. You further agree to promptly notify KPMG in writing if you become aware of any
          event
          or action which might reasonably impair KCC’s security, such as improper access to the password of an
          Authorised
          User.
        </li>
        <li>
          You acknowledge that, whilst KPMG has designed KCC with information security in mind and has taken steps to
          safeguard the security of KCC by way of the measures described in the KCC online privacy statement, KPMG
          cannot
          guarantee that KCC is invulnerable to hacking or other unauthorized access by third parties. You also
          acknowledge
          that transmission of information over the Internet is not entirely secure and there is always the possibility
          of
          unauthorized interception by third parties.
        </li>
        <li>
          KPMG does not guarantee that any content posted on KCC will be free from viruses and/or other code that may
          have
          contaminating or destructive elements. It is your responsibility to implement appropriate IT security
          safeguards
          (including anti-virus and other security checks) to satisfy its particular requirements as to the safety and
          reliability of content it provides and accesses through KCC. KPMG accepts no responsibility for the content of
          any
          third-party websites and hyperlinks to which may be featured on KCC.
        </li>
        <li>
          Technical factors such as bandwidth, network configurations, and computer browser settings can affect KCC’s
          speed
          and accessibility. KPMG does not guarantee the continuous, uninterrupted or error-free operability of KCC, or
          compatibility with your computer browser or any other part of its computing systems. You acknowledge that
          access
          to KCC may be suspended, limited, denied or disabled at any time and that content posted on KCC may not be
          recoverable. You are responsible for ensuring that as an Authorised User, you retain copies of all content
          posted
          on KCC. KPMG has no responsibility for recovering or providing to you any content posted on KCC.
        </li>
        <li>
          If you breach any of its obligations under these Terms of Use and any claim is made or threatened against
          either
          KPMG or other KPMG member firm(s) (individually and collectively “the KPMG Party”) by a third party (including
          without limitation claims concerning the posting by you of Prohibited Content), you shall compensate the KPMG
          Party, hold the KPMG Party harmless and reimburse the KPMG Party for and protect the KPMG Party against, any
          loss,
          damage, expense or liability incurred by the KPMG Party which results from or arises from or is connected with
          any
          such breach and any such claim. In this clause “you” includes all Authorised Users and “the KPMG Party”
          includes
          each and all partners, members, directors, employees, agents of the KPMG Party together with any entity
          controlled
          by or associated with the KPMG Party.
        </li>
        <li>
          You are solely responsible for all use you make of KCC and of the content posted on KCC. Except as expressly
          set
          out in these Terms of Use, no implied conditions, warranties or other terms apply to KCC or any KPMG Content.
          Nothing in these Terms of Use limits or excludes KPMG’s liability for death or property damage caused by its
          gross
          negligence or for fraudulent misrepresentation or any other liability that may not, under applicable law, be
          limited or excluded. Subject to the foregoing, in no event shall KPMG be liable to you for any indirect or
          consequential losses, or for any loss of profit, revenue, contracts, data, goodwill or other similar losses.
          KPMG’s liability arising from or in connection with these Terms of Use constitutes part of KPMG’s liability
          under
          the agreement concluded between parties and is subject to the relevant provisions concerning liability
          thereunder
          if any except for those explicitly provided herein.
        </li>
        <li>
          Upon the termination of the services for any reason, all further access to and use of KCC by you must
          immediately
          cease and KPMG may deactivate or delete related user accounts, unless otherwise required by applicable law or
          professional standards to maintain such accounts. KPMG reserves the right to terminate your access to KCC for
          any
          reason, including without limitation in the event KPMG becomes aware of any unauthorized use of KCC by
          Authorised
          Users, or breach by Authorised Users of these Terms of Use.
        </li>
      </ul>
    </el-dialog>

    <el-dialog title="个人信息收集与处理告知同意书" :visible.sync="cnPersonDialogVisible" width="640px">
      毕马威为帮助您访问KCC*（即毕马威智联平台）及支持您对该平台的使用（ “目的”
      ）而从贵方获取的个人信息，将由毕马威根据中华人民共和国《个人信息保护法》、中国香港特别行政区《个人资料（私隐）条例》以及澳门特别行政区《个人资料保护法》（统称为 “适用法规” ）以及毕马威的
      <a href="https://kpmg.com/cn/zh/home/misc/privacy.html" target="_blank" class="link">在线隐私声明</a>
      及<a href="https://assets.kpmg.com/content/dam/kpmg/cn/pdf/zh/2023/03/kpmg-china-privacy-statement.pdf"
        target="_blank" class="link">毕马威中国隐私声明</a> ( 统称为“隐私声明”) 进行收集、使用、处理及保存。
      <ul style="font-style:italic;padding:8px 0;">
        （*本声明适用于KCC的“授权用户”（其定义详见《毕马威智联平台使用条款》；在本声明中未约定的、有关您对KCC的访问及使用的各项事宜，均以《毕马威智联平台使用条款》为准）
      </ul>
      <ul style="padding:8px 0;">
        为上述目的并为遵守适用法规的要求，您在此同意向我方提供以下个人信息：
      </ul>
      <ul style="list-style: decimal;padding:0 20px;">
        <li>您的以下个人信息，以便毕马威能够为您注册在KCC平台中的用户账户。</li>
        <p>(a) 您的用户名及工作电子邮箱地址（作为您的KCC登录账户）。</p>
        <p>(b) 若您同意，您还可以选择提供个人手机号码；该号码仅被用于向您发送登录KCC时的短信验证码、和/或找回密码时所需的短信验证码
          <span
            style="font-style:italic;padding:8px 0;">（注：您的手机号码需被分享至腾讯云计算（北京）有限责任公司（“腾讯云”），由腾讯云通过其通讯资源合作伙伴提供腾讯云短信服务。若您对腾讯云如何处理手机号码有任何问题或意见，您可通过
            <a href="mailto:Dataprivacy@tencent.com" target="_blank"
              class="link">Dataprivacy@tencent.com</a>与其联系）</span>。
        </p>
        <li>对于与审计业务有关的文件传输，我方会收集您通过KCC向毕马威传输的审计相关文件当中可能包含的个人信息，此等文件用于毕马威根据其与您所在的公司（作为我方的审计客户）与毕马威签订的审计业务条款、提供审计服务。</li>
        <li>
          对于与非审计业务有关的文件传输，我方会收集您通过KCC向毕马威传输的非审计相关文件中可能包含的个人信息，此等文件用于毕马威根据其与您所在的公司（作为我方的非审计业务客户）与毕马威签订的非审计业务条款（或与您的公司有关联的第三方与毕马威订立的非审计业务条款）、提供非审计相关服务。
        </li>
      </ul>
      <ul style="padding:8px 0;">
        请注意，如果贵方不能提供上述个人信息，我方可能难以履行上述目的。
      </ul>
      <ul style="padding:8px 0;">
        上述目的实现后，我方将根据适用法规保留、储存或销毁任何包含贵方个人信息的资料。在任何情况下，我方保留贵方个人信息的期限将不会超过实现目的所需或适用法规所允许的期限。
      </ul>
      <ul style="padding:8px 0;">
        如果您需要向毕马威提供其他个人的个人信息，您需确认您已向相关人士告知其个人信息将被如何收集、使用、披露和转移，包括您向毕马威提供其个人信息、以及毕马威向第三方提供其个人信息（仅适用于非审计相关业务）的情况，且您已就此获得此等人士的授权和同意。
      </ul>
      <ul style="padding:8px 0;">
        由于贵方向我方提供的前述个人信息当中可能会包含为实现上述目的所需的敏感个人信息，因此，我方需要贵方在此明确同意毕马威为上述目的收集和处理贵方个人信息。
      </ul>
      <ul style="padding:8px 0;">
        贵方有权随时撤回贵方对我方以上述方式处理贵方个人信息的同意。贵方也可查阅、更正或查询我方保存的贵方个人信息。如果贵方希望行使上述权利，可发送请求至<a
          href="mailto:cn-fmdataprivacy@kpmg.com" class="link" target="_blank">cn-fmdataprivacy@kpmg.com</a>或毕马威KCC支持团队
        <a href="mailto:cnfmkpmgclicbt@kpmg.com" class="link" target="_blank">cnfmkpmgclicbt@kpmg.com</a>。
      </ul>
    </el-dialog>

    <el-dialog title="Notification and Consent Statement on Collection and Processing of Personal Information"
      :visible.sync="enPersonDialogVisible" width="640px">
      The personal information that KPMG receives from you for the purpose of KPMG providing you access to and
      supporting
      your use of KCC* (“Purpose”) are collected, used, processed and retained in accordance with the Personal
      Information
      Protection Law of the People’s Republic of China, Personal Data (Privacy) Ordinance of Hong Kong (SAR) and
      Personal
      Data Protection Act of Macau (SAR) (collectively “Applicable Laws”) and KPMG's
      <a href="https://kpmg.com/cn/en/home/misc/privacy.html" target="_blank" class="link"> Online Privacy Statement</a>
      and <a href="https://assets.kpmg.com/content/dam/kpmg/cn/pdf/en/2023/03/kpmg-china-privacy-statement.pdf"
        target="_blank" class="link">KPMG China Privacy Statement</a> (collectively “Privacy Statement”).
      <ul style="font-style:italic;padding:8px 0;">
        (*KCC refers to KPMG Collaboration Centre. This Statement applies if you are an Authorised User as defined in
        the
        “KCC Terms of Use”; anything not stated herein regarding your access and use of KCC shall be subject to the
        Terms of
        Use).
      </ul>
      <ul style="padding:8px 0;">
        To serve the Purpose mentioned above, you hereby agree to provide KPMG with the following personal information:
      </ul>
      <ul style="list-style: decimal;padding:0 20px;">
        <li>The following personal information will be required to enable KPMG to register you as a KCC user and to set
          up a
          KCC user access account for you.
          <p>(a) Your user name and work email address (to be used as KCC login account).</p>
          <p>(b) If you prefer, you may also choose to provide your mobile phone number, which will only be used to send
            you
            SMS verification code for log-in and/or for retrieving your password to KCC
            <span style="font-style:italic;padding:8px 0;">(note: your mobile phone number will be shared with Tencent
              Cloud
              Computing (Beijing) Co., Ltd (“Tencent Cloud”) which provides Tencent SMS service via its telecom resource
              partners; Tencent Cloud can be contacted via
              <a href="mailto:Dataprivacy@tencent.com" target="_blank" class="link">Dataprivacy@tencent.com</a> if you
              have
              questions or comments to raise as to how it processes the phone number).
            </span>
          </p>
        </li>
        <li>For file transfers relating to audit engagements, personal information as may be contained in the audit
          related
          documents which you transfer to KPMG via KCC for KPMG to perform audit services pursuant to the audit
          engagement
          terms entered into by your company (being an audit client) with KPMG.</li>
        <li>For file transfers relating to non-audit engagements, personal information as may be contained in the
          non-audit
          related documents which you transfer to KPMG via KCC for KPMG to perform non-audit related services pursuant
          to
          the non-audit engagement terms entered into by your company (being a non-audit client) with KPMG or relating
          to a
          non-audit engagement entered into by a third party with KPMG in which your company is related to.</li>
      </ul>
      <ul style="padding:8px 0;">
        Please note that if you are not able to provide us with the above personal information, we may not be able to
        carry
        out the Purpose accordingly.
      </ul>
      <ul style="padding:8px 0;">
        Once the above Purpose is achieved, any materials containing your personal information will be retained, stored,
        or
        destroyed in accordance with the Applicable Laws. In any event, your personal information will not be retained
        longer than is necessary to achieve the Purpose or permitted by the Applicable Laws.
      </ul>
      <ul style="padding:8px 0;">
        If you are required to provide personal information of other individuals to KPMG, you confirm that you have
        informed
        those individuals of the collection, use, disclosure and transfer of their personal information from you to KPMG
        and
        from KPMG to third parties (only applicable in the case of non-audit related engagements), and that you have
        obtained those individuals’ authorisation and consent for you and KPMG to do so.
      </ul>
      <ul style="padding:8px 0;">
        As the personal information you provide to KPMG may contain sensitive personal information as necessary for the
        Purpose mentioned in the above, your explicit consent is therefore obtained for KPMG to collect and process such
        personal information for the Purpose above.
      </ul>
      <ul style="padding:8px 0;">
        You have the right to withdraw your consent to the processing in the above manner at any time. You are also
        entitled
        to access, correct, or enquire about your personal information held by KPMG. If you wish to exercise your rights
        aforementioned, you may do so by sending your request to <a href="mailto:cn-fmdataprivacy@kpmg.com" class="link"
          target="_blank">cn-fmdataprivacy@kpmg.com</a> or KPMG KCC Team <a href="mailto:cnfmkpmgclicbt@kpmg.com"
          class="link" target="_blank">cnfmkpmgclicbt@kpmg.com</a>.
      </ul>
    </el-dialog>

    <contact-us v-if="supportVisible" :onCancel="toogleSupportVisible" :account="param.account" />

    <!--    video-->
    <el-dialog title="" class="video-player-cls" :visible.sync="videoDisplay" :close-on-click-modal="false"
      append-to-body width="600" :before-close="handleCloseVideo">
      <video width="100%" controls oncontextmenu="return false" controlslist="nodownload" v-if="videoDisplay" autoplay>
        <source :src="video" type="video/mp4">
        您的浏览器不支持 video 标签。
      </video>
    </el-dialog>
    <el-dialog :title="$t('set_session_title')" :visible.sync="setSessionVisible" width="20%" :show-close="false">
      <div class="center">
        <el-input-number v-model="outTime" :precision="1" :step="0.5" :max="8" :min="0.5"></el-input-number>
        {{ $t('hour') }}
        <div class="tip" style="color:#fd349c; text-align: left;">
          <i class="el-icon-info"></i>
          {{ $t('outTimeTips') }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="setSessionVisible = false">{{ $t('btn_cancel') }}</el-button> -->
        <el-button type="primary" @click="setOutTime">{{ $t('btn_confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import SvgIcon from "@/components/svgIcon";
import VBottom from '@/components/common/Bottom.vue'
import ContactUs from "@/components/common/ContactUs"
import { UserInput, encryptForGCM } from '@/utils/index'
import { isEmail, isMobile } from "@/utils/validate";
import LoginTop from '@/components/common/LoginTop'
import windowConfig from '@/utils/windowConfig'

const regionDict = { "+86": "CN", "+852": "HK", "+853": "MO" };
export default {
  data() {
    return {
      regionPhone: "+86",
      isForgot: false,
      currentStep: 1,
      manualURL: windowConfig.helpURL.howToUploadPBCFile,
      videoDisplay: false,
      codeBtn: false,
      aesKey: '',
      isHaveAccount: false,
      // 标记input focus
      accountFocus: false,
      pwdFocus: false,
      codeFocus: false,
      phoneFocus: false,
      phoneFlag: true,
      accountFlag: true,
      deactivateFlag: false,
      btnLoading: false,
      codeLoading: false,
      loginLoading: false,
      param: {
        account: '',
        password: '',
        receiverNumber: "",
        verificationCodeType: "SMS",
        verificationCode: "",
        termOfUse: [],
      },
      timer: '',
      useTermFlag: false,   // 用户是否同意过使用条款
      // firstLogin: false,
      enDialogVisible: false,
      cnDialogVisible: false,
      supportShow: false,
      supportVisible: false,
      video: require('@/assets/videos/login-to-kcc.mp4'),
      cnPersonDialogVisible: false,
      enPersonDialogVisible: false,
      errorMsg: "",
      setSessionVisible: false,
      outTime: '',
      verificationType: "LOGIN",
      phoneDisabled: false,
      loginInfo: {},
      tabs: [
        {
          code: "SMS",
          icon: "Mobile",
          name: "login.SMS"
        },
        {
          code: "EMAIL",
          icon: "Email",
          name: "login.Email"
        }
      ],
      getCodeSecond: 0,
      userTermDisplayType: "",
      oldPwdFlag: true,
      firstLoginFlag: false,
    }
  },
  computed: {
    appendLoginFormHeight() {
      // 条款更新后, 需要用户重新确认新的条款, 此时"忘记密码"和"同意"条款的选项会同时出现在页面上, 原页面布局会出现重叠, 为这种情况额外增加一定height
      return `ms-login ${this.isHaveAccount && !this.useTermFlag && !this.firstLogin ? 'extra-height' : ''}`
    },
    nextLabel() {
      return this.currentStep < 3 ? this.$t("login.continue") : this.$t("login.next");
    },
    errorMsgShow() {
      return this.$t(this.errorMsg)
    },
    //ALL SMS/EMAIL都展示   SMS时SMS展示
    firstLogin() {
      return this.userTermDisplayType === "ALL" || this.userTermDisplayType === "SMS" && this.param.verificationCodeType === "SMS"
    },
    rules() {
      const _rules = {
        verificationCode: [{ required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' }],
        receiverNumber: [],
        account: [
          { pattern: isEmail, trigger: 'change', message: this.$t('CLIENT_USER_004') }
        ],
        password: [
          { required: true, message: this.$t('FORM_VALIDATE_PASSWORLD'), trigger: 'blur' },
          // {
          //   pattern: UserInput.reg2,
          //   trigger: 'blur',
          //   message: this.$t('ILLEGAL_USER_INPUT_03')
          // },
        ],
      };
      //同意协议是否展示
      if (this.firstLogin) {
        _rules.termOfUse = [{
          type: 'array',
          required: true,
          message: this.$t('TERM_OF_USE_MUST_BE_AGREED'),
          trigger: 'change'
        }]
      } else {
        _rules.termOfUse = []
      }

      if (!this.phoneDisabled) {
        _rules.receiverNumber = [{ pattern: isMobile, trigger: 'change', message: this.$t('login.validatePhone') }]
      } else {
        _rules.receiverNumber = [];
      }
      //新账号 12位校验
      if (!this.oldPwdFlag) {
        _rules.password = [
          { required: true, message: this.$t('FORM_VALIDATE_PASSWORLD'), trigger: 'blur' },
          // {
          //   pattern: UserInput.reg2,
          //   trigger: 'blur',
          //   message: this.$t('ILLEGAL_USER_INPUT_03')
          // },
          // { min: 12, max: 100, message: this.$t('FORM_VALIDATE_LOGIN_MAX'), trigger: 'blur' }
        ];
      } else {
        _rules.password = [
          { required: true, message: this.$t('FORM_VALIDATE_PASSWORLD'), trigger: 'blur' },
          // {
          //   pattern: UserInput.reg2,
          //   trigger: 'blur',
          //   message: this.$t('ILLEGAL_USER_INPUT_03')
          // },
        ]
      }
      console.log(_rules, 111)
      return _rules;

    },
  },

  methods: {
    async next() {
      this.resultFlag = false;
      if (this.currentStep === 1) {
        this.$refs.accountInput.blur()
        await this.checkAccount();
      } else if (this.currentStep === 2) {
        await this.preLogin();
      }

      if (!this.resultFlag || this.deactivateFlag) return;
      this.currentStep++;
    },
    handleTabClick() {
      this.param.verificationCode = "";
    },
    openVideo() {
      this.videoDisplay = true
    },
    handleCloseVideo() {
      this.videoDisplay = false
    },
    focusAccount() {
      this.accountFlag = true
      this.accountFocus = true
    },
    handlePhoneBlur() {
      this.phoneFlag = this.param.receiverNumber;
      const results = isMobile(this.regionPhone + this.param.receiverNumber);
      if (!this.param.receiverNumber) { this.errorMsg = "login.emptyPhone"; return }
      if (!this.phoneDisabled && !results) {
        this.phoneFlag = false;
        this.errorMsg = "login.validatePhone";
      }
    },
    submitForm() {
      this.$refs.login.validate(async valid => {
        if (valid) {
          try {
            const pass = encryptForGCM(this.param.password, this.aesKey)
            let params = {
              userAccount: this.param.account,
              approval: pass,
              verificationCode: this.param.verificationCode,
              verificationCodeType: this.param.verificationCodeType,
              phone: this.regionPhone + this.param.receiverNumber,
            }
            params.checkFlag = !!this.param.termOfUse.length // 判断用户是否有勾选的操作
            this.loginLoading = true
            const res = await API.common.login(params)
            if (res.code == '1' && res.data) {
              let locale = localStorage.getItem('lang')
              if (!locale || locale == '' || locale == null) {
                this.$i18n.locale = 'zh'
                localStorage.setItem('lang', 'zh')
              } else {
                this.$i18n.locale = localStorage.getItem('lang')
              }
              sessionStorage.setItem('JSESSIONID', res.data.tokenId)
              localStorage.setItem('JSESSIONID', res.data.tokenId)
              // const menuCodeList = await this.queryMenuList(res.data.siteInfo.siteId)
              console.log(111111111111111111111111)
              this.loginLoading = false
              if (res.data.isFirstLogin) {
                this.loginInfo = res
                // 首次登录要展示配置过期时常
                localStorage.setItem('first_login_homepage_show_set_session', 1)
                // 如果是首次登录，第一次进首页的时候要展示视频，并且清除这个flag
                localStorage.setItem('first_login_homepage_show_video', 1)

                this.$store.commit('common/setUser', this.loginInfo.data)
                this.$store.commit('common/setIsFirstLogin', this.loginInfo.data.isFirstLogin)
                this.$store.commit('common/setIsFirstLoginFlag', this.loginInfo.data.isFirstLogin)
                this.$store.commit('common/setSite', this.loginInfo.data.siteInfo)
                //this.$store.commit('common/setInitPwd', pass)

                // 这个标记为true的时候需要重设密码，没重设就不让进
                localStorage.setItem('please_change_password', 1)
                await this.$router.push('/changePassword')

              } else {
                localStorage.removeItem('please_change_password')
                this.$store.commit('common/setUser', res.data)
                this.$store.commit('common/setIsFirstLogin', res.data.isFirstLogin)
                this.$store.commit('common/setIsFirstLoginFlag', res.data.isFirstLogin)

                if (res.data.showSetSession == '1') {
                  // 所有用户仅弹出一次配置超时时间
                  localStorage.setItem('first_login_homepage_show_set_session', 1)
                }
                if (res.data.changePeriod >= 85 && res.data.changePeriod < 90) {
                  this.$message({
                    message: this.$t('PASSWORD_CHANGE_MESS'),
                    type: 'warning',
                    duration: 6000
                  });
                }
                if (res.data.changePeriod >= 90) {
                  this.$store.commit('common/setSite', res.data.siteInfo)
                  this.$message({
                    message: this.$t('PASSWORD_EXPIRED_MESS'),
                    type: 'warning',
                    duration: 6000
                  });
                  await this.$router.push('/changePassword')
                } else if (res.data.userType == '2') {
                  this.$store.commit('common/setSite', res.data.siteInfo)

                  const _redirectUrl = JSON.parse(sessionStorage.getItem('redirectUrl'));
                  _redirectUrl ? await this.$router.replace({
                    name: _redirectUrl.name,
                    query: _redirectUrl.query
                  }) : await this.$router.push('/businessHome')
                  sessionStorage.removeItem('redirectUrl')
              } else if (res.data.userType == '1' && !res.data.hasSiteBind && res.data.isSystemAdmin) {
                  await this.$router.push('/system')
                } else {
                  await this.$router.push('/businessHome')
                }
              }

            } else if (res.code == 'CLIENT_USER_002') {
              this.$message.error(res.errDetails.msg)
            } else if (res.code === 'USER_IP_NOTAVALIABLE') {
              let curIp = res.data
              this.$message({
                dangerouslyUseHTMLString: true,
                message: this.$t('USER_IP_NOTAVALIABLE', { ip: curIp }),
                type: 'error'
              });
            } else {
              this.$message.error(this.$t(res.code))
            }
          } catch (error) {
            this.loginLoading = false
          } finally {
            this.loginLoading = false
          }
        }
      })
    },
    async preLogin() {
      if (!this.param.password) {
        this.$message.error(this.$t('FORM_VALIDATE_PASSWORLD'));
        return;
      }
      try {
        this.btnLoading = true
        this.phoneDisabled = false;
        const pass = encryptForGCM(this.param.password, this.aesKey);
        await API.common.preLogin({ userAccount: this.param.account, approval: pass }).then((res) => {
          if (res.code === '1') {
            const { phone } = res.data;
            this.handlePhoneNumber(phone);
            this.phoneDisabled = !!phone;
            this.resultFlag = true;
          } else if (res.code == 'CLIENT_USER_002') {
            this.$message.error(res.errDetails.msg)
            this.btnLoading = false
          } else {
            this.$message.error(this.$t(res.code))
            this.btnLoading = false
          }
        })
      } catch (error) {
        console.error(error)
        this.$message.error(this.$t('CLIENT_USER_002'));
      } finally {
        this.btnLoading = false
      }

    },
    async checkAccount() {
      if (this.param.account) {
        this.btnLoading = true
        this.resultFlag = false;
        this.deactivateFlag = false;
        this.oldPwdFlag = true;
        await API.common.checkAccount({ param: this.param.account }).then((res) => {
          if (res.code === '1') {
            if (!res.data.deactivate) {
              this.accountFlag = true
              this.isHaveAccount = true
              this.btnLoading = false
              this.useTermFlag = res.data.useTermFlag
              this.userTermDisplayType = res.data.userTermDisplayType
              this.supportShow = true
              const phone = res.data.phone;
              if (phone) {
                this.phoneDisabled = true;
              }
            } else {
              this.deactivateFlag = true;
              this.accountFlag = false
              this.isHaveAccount = false
              this.btnLoading = false
              this.errorMsg = 'deactivated_error'
            }
            this.resultFlag = true;
            this.oldPwdFlag = res.data.oldPwdFlag;
            this.firstLoginFlag = res.data.firstLoginFlag;

          } else {
            this.$message.error(this.$t(res.code))
            this.btnLoading = false
          }
        })
      } else {
        this.errorMsg = 'account_check_error'
        this.accountFlag = false
        this.isHaveAccount = false
      }
    },

    handlePhoneNumber(phone) {
      if (!phone) return;
      if (phone.indexOf("+86") > -1) {
        this.param.receiverNumber = phone.substring(3);
        this.regionPhone = phone.substring(0, 3);
      } else {
        this.param.receiverNumber = phone.substring(4);
        this.regionPhone = phone.substring(0, 4);
      }
    },

    getCode() {
      if (this.param.verificationCodeType === 'SMS' && !this.param.receiverNumber) {
        this.errorMsg = 'login.emptyPhone';
        return;
      }
      if (this.param.verificationCodeType === 'SMS' && !this.phoneDisabled && !isMobile(this.regionPhone + this.param.receiverNumber)) {
        return
      }
      this.codeLoading = true
      const params = {
        verificationCodeType: this.param.verificationCodeType,
        receiverNumber: this.regionPhone + this.param.receiverNumber,
        verificationType: this.verificationType,
        smsLang: this.$i18n.locale,
        region: regionDict[this.regionPhone],
        account: this.param.account
      };
      API.common
        .verificationLogin(params)
        .then(res => {
          if (res.code == '1') {
            this.codeLoading = false
            const _verificationCodeType = this.param.verificationCodeType
            this.codeBtn = true
            this.$message({
              dangerouslyUseHTMLString: true,
              message: _verificationCodeType == 'SMS' ? this.$t('verification_code_send_success4SMS') : this.$t('verification_code_send_success4Email'),
              type: 'success'
            })
            const that = this
            that.getCodeSecond = 60
            that.timer = setInterval(() => {
              if (that.getCodeSecond != 0) {
                that.getCodeSecond = that.getCodeSecond - 1
              } else {
                clearInterval(that.timer)
                that.codeBtn = false
                that.getCodeSecond = 0
              }
            }, 1000)
          } else {
            this.$message.error(this.$t(res.code))
          }
        })
        .catch(err => {
          this.$message.error(this.$t('msg_error'))
        })
        .finally(() => {
          this.codeLoading = false
        })
    },

    getAesKey() {
      API.common.secretKey().then(res => {
        if (res.code == '1') {
          this.aesKey = res.data
          localStorage.setItem('aesKey', res.data)
        }
      })
    },
    goTo() {
      this.$router.push({ name: "forgetPassword", query: { account: this.param.account } })

    },
    sendEmail(data) {
      this.emailBtnLoading = true
      const accountList = [this.param.account]
      const params = {
        userAccounts: accountList,
        siteId: "111"
      }
      API.clientUser
        .sendLoginNotificationEmail(params)
        .then(res => {
          if (res.code == '1') {
            this.$message.success(this.$t('send_pws_success'))
            // 发送成功后重置一下提示气泡的状态
            // this.checkIfUnsendPwdUserExist()
          } else {
            this.$message.error(this.$t(res.code))
          }
        })
        .catch(e => {
          console.error(e);
          this.$message.error(this.$t('SYS_USER_003'))
        })
        .finally(() => {
          this.emailBtnLoading = false
        })
    },
    navigateToTermOfUse() {
      if (this.$i18n.locale === 'zh') {
        this.cnDialogVisible = true
      } else {
        this.enDialogVisible = true
      }
    },
    navigateToPerson() {
      if (this.$i18n.locale === 'zh') {
        this.cnPersonDialogVisible = true
      } else {
        this.enPersonDialogVisible = true
      }
    },
    toogleSupportVisible() {
      this.supportVisible = !this.supportVisible
    },
    async setOutTime() {
      const res = await API.pbc.setTime({ param: (this.outTime * 60).toString() })
      if (res.code === '1') {
        this.$message.success(this.$t('msg_success'))
        this.$store.commit('common/setUser', this.loginInfo.data)
        this.$store.commit('common/setIsFirstLogin', this.loginInfo.data.isFirstLogin)
        if (this.loginInfo.data.changePeriod >= 85 && this.loginInfo.data.changePeriod < 90) {
          this.$message.warning(this.$t('PASSWORD_CHANGE_MESS'))
        }
        this.$store.commit('common/setSite', this.loginInfo.data.siteInfo)
        await this.$router.push('/changePassword')
      } else {
        this.$message.error(this.$t(res.code))
      }
      this.setSessionVisible = false
    },
  },
  mounted() {
    localStorage.removeItem('please_change_password')

    this.getAesKey()
  },
  components: {
    VBottom,
    ContactUs,
    LoginTop,
    SvgIcon
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style scoped>
::v-deep .step3 .el-step__head.is-success {
  left: -15px;
}

.mr_4 {
  margin-right: 4px;
}

::v-deep .el-steps--simple {
  padding: 13px 0;
  background: #fff;
}

::v-deep .step-number .el-step__head {
  display: none;
}

.left-20 {
  left: 20px;
}

::v-deep .el-step__title {
  display: flex;
  align-items: center;
  white-space: nowrap;

}

::v-deep .el-step.is-simple .el-step__title {
  font-weight: 400;
  font-size: 14px;
  line-height: 28px;
}

::v-deep .el-step.is-simple:not(:last-of-type) .el-step__title {
  max-width: 100%;
  width: 100%;
}

::v-deep .el-step.is-simple .el-step__head {
  padding-right: 4px;
}

::v-deep .el-icon-question {
  color: #acb2bd;
  z-index: 100;
}

.circle-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  left: -10px;
  position: relative;
  flex: 1;
}

.circle-group.en {
  left: 0 !important;
}

.big-circle {
  display: inline-block;
  width: 6px;
  height: 6px;
  background: #e0e3e9;
  border-radius: 50%;
  /* margin-left: 4px; */
}

.small-circle {
  display: inline-block;
  width: 4px;
  height: 4px;
  background: #e8ebf1;
  border-radius: 50%;
  margin-left: 8px;
}

.step-arrow {
  display: inline-block;
  height: 8px;
  margin-left: 10px;
}

.step-arrow::before {
  content: '';
  display: inline-block;
  position: absolute;
  height: 2px;
  width: 8px;
  background: #d5d8df;
  -webkit-transform: rotate(-45deg) translateY(8px);
  transform: rotate(-45deg) translateY(8px);
  -webkit-transform-origin: 0 11px;
  transform-origin: 0 11px;
}

.step-arrow::after {
  content: '';
  display: inline-block;
  position: absolute;
  height: 2px;
  width: 8px;
  background: #d5d8df;
  -webkit-transform: rotate(45deg) translateY(6px);
  transform: rotate(45deg) translateY(6px);
  -webkit-transform-origin: 100% 100%;
  transform-origin: 100% 100%;
}

::v-deep .el-step__arrow {
  display: none !important;
}

::v-deep .el-step__head.is-success,
::v-deep .el-step__title.is-success {
  color: #00338d;
  border-color: #00338d;
}

::v-deep .el-step__icon.is-text {
  color: #fff;
  border-color: #00338d;
  background: #00338d !important;
  width: 15px !important;
  height: 15px !important;
}

::v-deep .el-step__head.is-process,
::v-deep .el-step__title.is-process {
  color: #C0C4CC;
  border-color: #C0C4CC;
}

::v-deep .en-last .el-step:last-child .el-step__main {
  position: absolute;
  right: -30px;
  left: none;
  white-space: nowrap;
}

::v-deep .zh-last .el-step:last-child .el-step__main {
  position: relative;
  left: -15px;
}

::v-deep .en-last .el-step:last-child {
  margin-right: 30px;
}

.mb_20 {
  margin-bottom: 20px
}

.mb_40 {
  margin-bottom: 40px !important;
}

.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("~@/assets/img/loginbg.png") center center/100% 100% no-repeat fixed;
}

.login-top {
  position: relative;
  width: 100%;
  height: 100%;
}

.content-part {
  height: calc(100% - 193px);
  position: relative;
}

.left-logo {
  position: absolute;
  left: 22%;
  top: 25%;
  width: 575px;
  height: 369px;
}

.ms-login {
  position: absolute;
  right: 10%;
  top: 10%;
  width: 570px;
  height: 636px;
  background: rgba(255, 255, 255, 1);
  overflow: hidden;
  border-radius: 8px;
  padding: 45px;
}

.title-line {
  margin-bottom: 10px;
}

.font-light {
  color: #00338d;
  font-size: 18px;
  /* font-family: 'KPMG Light', 'KPMG'; */
  vertical-align: middle;
  margin: 10px 0 25px 0;
}

.ms-title {
  color: #00338d;
  font-size: 42px;
  font-family: 'NotoSans Bold', 'KPMG';
  vertical-align: middle;
}

.ms-title.en-lang {
  font-family: 'KPMG Bold', 'KPMG';
}

/* .ms-content .item {
    margin-bottom: 37px;
  } */
.ms-content .item.code-item {
  margin-bottom: 22px;
}

.login-btn {
  height: 100%;
  box-sizing: border-box;
  background-color: #3879eb;
  font-size: 21px !important;
}

.next-btn {
  /* height: 100%; */
  box-sizing: border-box;
  background-color: #3879eb;
  font-size: 21px !important;
  width: 100%;
  margin-top: 30px;
  /* text-align: center; */
}

.login-tips {
  display: inline-block;
  font-size: 21px;
  color: #005eb8;
  text-align: left;
  cursor: pointer;
  margin-top: 30px;
}

.footer-login {
  width: 480px;
  height: 60px;
  margin: 27px auto 0;
}

.manual-text {
  position: absolute;
  padding: 0 30px 30px;
  font-size: 21px;
  color: #005eb8;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
}

.manual-text1 {
  position: absolute;
  padding: 0 30px 30px;
  font-size: 21px;
  color: #005eb8;
  bottom: 0;
  left: 0;
  right: 50%;
  text-align: left;
}

.manual-text2 {
  position: absolute;
  padding: 0 30px 30px;
  font-size: 21px;
  color: #005eb8;
  bottom: 0;
  left: 0;
  /* right: 0; */
  text-align: center;
  width: 100%;
  margin: 0 auto;
}

.manual-text2 a {
  color: #005eb8;
}

.manual-text .help,
.manual-text1 .help,
.manual-text2 .help {
  display: inline-block;
  cursor: help;
  text-align: center;
  font-family: 'Arial', '思源黑体', 'KPMG';
}

.login-item {
  width: 100%;
  border-radius: 8px;
  height: 44px;
  font-size: 21px;
  border: none;
  background-color: #1e49e2;
  border-color: #1e49e2;
}

.login-item:hover {
  background-color: #3879eb;
}

.login-terms-font {
  font-size: 18px;
  display: flex;
}

::v-deep .el-checkbox-group+.el-form-item__error {
  padding-left: 21px;
  margin-top: -4px;
}

ul>li {
  padding: 2px 10px;
}

/*----------video  css  start-----*/
.video-player-cls ::v-deep .el-dialog {
  background-color: rgba(255, 255, 255, 0);
}

.video-player-cls ::v-deep .el-dialog .el-dialog__header,
.video-player-cls ::v-deep .el-dialog .el-dialog__body {
  padding: 0 !important;
  border-bottom: none;
}

.video-player-cls ::v-deep .el-dialog .el-dialog__header .el-dialog__headerbtn {
  top: -20px;
  right: -20px;
  border: 1px solid #fff;
  border-radius: 50%;
}

.video-player-cls ::v-deep .el-dialog .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

::v-deep .el-input__inner {
  font-size: 16PX !important;
}

/*----------video  css  end-----*/
.center {
  text-align: center;
}

.tip {
  margin-top: 10px;
  color: #3879eb;
  font-size: 14PX;
}

.link {
  text-decoration: underline;
  color: #00338d;
}

::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #F5F7FA !important;
}

.font-weight {
  font-weight: 700;
}

.step-name {
  font-size: 12px;
  font-weight: 400;
}

::v-deep .step-name .el-step__icon {
  height: 20px;
  width: 20px;
}

::v-deep .step-name .el-step__icon .el-step__icon-inner {
  height: 12px;
  width: 12px;
  position: relative;
  top: -2px;
}

::v-deep .el-step.is-horizontal .el-step__line {
  top: 8px;
}

.cust-tabs {
  margin-bottom: 30px;
  height: 50px;
  border: none !important;
  box-shadow: none !important;

}

::v-deep .cust-tabs .el-tabs__item.is-active {
  border: none;
}

.cust-tabs .tab-label {
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  position: relative;
  color: rgb(38 47 63);
}

::v-deep .cust-tabs .el-tabs__item.is-active .tab-label {
  color: #005eb8 !important;
}

.way-icon {
  position: relative;
  top: -2px;
  margin-right: 4px;
}

.cust-tabs ::v-deep.el-tabs__content {
  display: none;
}

::v-deep .cust-tabs .el-tabs__header {
  height: 56px;
  padding: 0 10px !important;
  border-radius: 6px;
}

::v-deep .cust-tabs .el-tabs__nav-wrap {
  line-height: 56px;
}

::v-deep .cust-tabs .el-tabs__nav {
  width: 100%;
  line-height: 56px;
}

::v-deep .cust-tabs .el-tabs__item {
  width: 50%;
  text-align: center;
  border: none !important;
  height: 40px;
  padding: 3px 0;
  border-radius: 6px;
  color: rgb(38 47 63) !important;
  font-weight: 600 !important;
  position: relative;
  top: 5px;
}


::v-deep .el-input-group--prepend .phone-prepend {
  background: #fff;
  width: 220px;
  font-size: 12PX !important;

}

.zh-width {
  width: 150px !important;
}

::v-deep .el-input-group--prepend .el-select .el-input.is-focus .el-input__inner {
  border-color: #e3e4e6 !important;
  border-right-color: transparent;
}

::v-deep .el-input-group--prepend .el-select .el-input:hover .el-input__inner {
  border-color: #e3e4e6;
  border-top: 1px solid #e3e4e6;
  border-bottom: 1px solid #e3e4e6;
  border-right: 0;

}

::v-deep .phone-input .el-input__inner {
  border-left: none !important;
  border-radius: 0 !important;
}

::v-deep .phone-input .phone-prepend {
  border-radius: 12px 0 0 12px !important;
}
</style>
<style>
.help-popover-text {
  color: #005eb8;
  cursor: pointer;
}

.sub-list li {
  display: flex;
}

.sub-list li::before {
  content: attr(data-index);
  margin-right: 5px;
}
</style>
